import { NgClass } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { copyToClipboard, IconModule } from '@hglobal/fin-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { GlobalToastService } from '@iw/core/services';

import { ButtonComponent, TooltipComponent } from '..';

@Component({
  selector: 'iw-details-value',
  imports: [
    IconModule,
    ButtonComponent,
    TranslateModule,
    NgClass,
    TooltipComponent,
  ],
  templateUrl: './details-value.component.html',
  styleUrl: './details-value.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsValueComponent {
  readonly #toast = inject(GlobalToastService);
  readonly #translate = inject(TranslateService);

  readonly label = input<string>();
  readonly value = input<string | number>();
  readonly tooltipValue = input<string>();
  readonly valueClass = input<string>();
  readonly labelClass = input<string>();
  readonly valueToCopy = input<string | number>();
  readonly withCopyBtn = input(false, { transform: booleanAttribute });
  readonly iconUrl = input<string>();
  readonly iconName = input<string>();

  readonly copied = output<string>();

  async onCopy(event: MouseEvent) {
    event.stopPropagation();

    const textToCopy = this.valueToCopy() || this.value();

    await copyToClipboard(textToCopy.toString());

    const message = this.label()
      ? this.#translate.instant('common.copy.toast.message', {
          fieldName: this.#translate.instant(this.label()),
        })
      : this.#translate.instant('clipboard.addressCopied');

    this.#toast.showSuccess(message);
  }
}
